module.exports = __webpack_public_path__ + "assets/swap-battery.4c6928f8.svg";